import { useState, useEffect } from "react";
import "./Stylesheets/Navbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faBars, faPhone } from "@fortawesome/free-solid-svg-icons";
import InlineLeadForm from "./Components/InlineLeadForm";

export default function Navbar() {
  const [click, setClick] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY >= 100);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClose = () => setClick(false);
  const handleToggle = () => setClick((p) => !p);

  return (
    <>
      <header className={`nav-shell ${scrolled ? "is-scrolled" : ""}`} role="banner">
        <div className="nav-bar">

          {/* LEFT — nav links (desktop) / phone CTA (mobile) */}
          <div className="nav-left">
            <nav aria-label="Primary navigation">
              <ul className="nav-list">
                <li><a href="#Coaches">Coaches</a></li>
                <li><a href="#Schedule">Schedule</a></li>
                <li><a href="#Pricing">Sign Up</a></li>
                <li><a href="#FAQ">FAQ</a></li>
                <li><a href="#Contact">Contact</a></li>
                <li><a href="/store">Shop</a></li>
              </ul>
            </nav>

            {/* Mobile-only phone strip */}
            <a className="nav-phone-mobile" href="tel:+14169921169" aria-label="Call us">
              <FontAwesomeIcon icon={faPhone} className="nav-phone-mobile-icon" />
              <span className="nav-phone-mobile-inner">
                <span className="nav-phone-mobile-label">Call Now</span>
                <span className="nav-phone-mobile-number">(416) 992-1169</span>
              </span>
            </a>
          </div>

          {/* CENTER — wordmark (fades out when mobile menu opens) */}
          <a href="/" className={`nav-brand${click ? ' nav-brand--menu-open' : ''}`} aria-label="Richmond Hill Jiu-Jitsu">
            <span className="nav-brand-main">Richmond Hill</span>
            <span className="nav-brand-rule" aria-hidden="true" />
            <span className="nav-brand-sub">Jiu · Jitsu</span>
          </a>

          {/* RIGHT — phone CTA + hamburger */}
          <div className="nav-right">
            <a className="nav-call-cta" href="tel:+14169921169" aria-label="Call us">
              <FontAwesomeIcon icon={faPhone} className="nav-call-icon" />
              <span className="nav-call-inner">
                <span className="nav-call-label">Call Now</span>
                <span className="nav-call-number">(416) 992-1169</span>
              </span>
            </a>

            <button
              className="hamburger"
              onClick={handleToggle}
              aria-expanded={click}
              aria-label={click ? "Close menu" : "Open menu"}
            >
              <FontAwesomeIcon icon={click ? faTimes : faBars} />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile panel — sibling of header to avoid backdrop-filter stacking context */}
      <div
        className={`mobile-panel ${click ? "open" : ""} ${scrolled ? "less-margin" : ""}`}
        role="dialog"
        aria-modal={click}
      >
        <nav className="mobile-nav" aria-label="Mobile primary">

          <div className="mobile-brand">
            <span className="mobile-brand-main">Richmond Hill</span>
            <span className="mobile-brand-rule" aria-hidden="true" />
            <span className="mobile-brand-sub">Jiu · Jitsu</span>
          </div>

          <ul>
            <li><a href="#Coaches" onClick={handleClose}>Coaches</a></li>
            <li><a href="#Schedule" onClick={handleClose}>Schedule</a></li>
            <li><a href="#Pricing" onClick={handleClose}>Pricing</a></li>
            <li><a href="#FAQ" onClick={handleClose}>FAQ</a></li>
            <li><a href="#Contact" onClick={handleClose}>Contact</a></li>
            <li><a href="/store" onClick={handleClose}>Shop</a></li>
          </ul>

          <div className="mobile-cta-wrap">
            <div className="getstarted mobile-form" onClick={handleClose}>
              <InlineLeadForm />
            </div>
   
          </div>
        </nav>
      </div>
    </>
  );
}
